import styled from "styled-components/macro";

export const Container = styled.div`
  padding-top: 90px;
`;
